import { useContext, useState } from "react";
import ToggleIcon from "../assets/toggle.svg";
import NewChatIcon from "../assets/newChat.svg";
import ChatIcon from "../assets/Chat.svg";
import LogoutIcon from "../assets/Group.svg";
import { AuthContext } from "../context/authContext";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "../assets/delete.svg";
import { deleteSelectedChat } from "../services/chatService";
import SiteSettings from "../assets/siteSettings.svg";
import { CrownOutlined } from "@ant-design/icons";
import UpgradeModal from "./modals/UpgradeModal.jsx";
import HelpMenu from "./HelpMenu.jsx";
import DeleteChatModal from "./DeleteChatModal.jsx";

function Sidebar({
  toggle,
  setToggle,
  chats,
  onSelectChat,
  setNewChat,
  selectedChatId,
  setSelectedChatId,
  initials,
  userName,
  handleNewChat,
  updateChats,
  setDisplayFAQ,
  displayFAQ,
  setIsSettingsModalVisible,
}) {
  const { logout, creditBalance, isAdmin, userData } = useContext(AuthContext);
  const [hoveredChatId, setHoveredChatId] = useState(null);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const navigate = useNavigate();
  const [modalOpenChatId, setModalOpenChatId] = useState(null);

  const isSubscribed = userData?.subscribed || false;

  const handleSelect = (id) => {
    setNewChat(false);
    setSelectedChatId(id);
    onSelectChat(id);
    setDisplayFAQ(false);
    if (window.innerWidth < 768) {
      setToggle(!toggle);
    }
  };

  const handleToggle = () => {
    setToggle(!toggle);
  };

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const handleDeleteConfirm = async () => {
    await deleteSelectedChat(modalOpenChatId);
    setSelectedChatId(null);
    updateChats();
    setModalOpenChatId(null);
    if (window.innerWidth < 768) {
      setToggle(!toggle);
    }
  };

  const handleDeleteCancel = () => {
    setModalOpenChatId(null);
  };

  const handleOpenFaqs = () => {
    setDisplayFAQ(true);
    setSelectedChatId(null);
  };

  const handleOpenContactUs = () => {
    navigate("/contact-us");
  };

  const handleOpenSiteSettings = () => {
    navigate("/site-settings");
  };

  const handleRecharge = () => {
    navigate("/recharge");
  };

  const handleOpenSchedules = () => {
    navigate("/schedules");
  };

  const handleUpgradeClick = () => {
    setShowUpgradeModal(true);
  };

  const handleUpgradeClose = () => {
    setShowUpgradeModal(false);
  };

  const handleOpenTerms = () => {
    window.open("/terms-of-use", "_blank");
  };

  const handleOpenPrivacy = () => {
    window.open("/privacy-policy", "_blank");
  };

  return (
    <>
      <div
        className={`flex flex-col ${
          toggle ? "w-[290px] justify-between" : "w-[60px]"
        } h-screen bg-[#F9F9F9] p-[15px] transition-all duration-300 font-Poppins overflow-x-hidden`}
        style={{
          position: "fixed",
          maxWidth: toggle ? "290px" : "60px",
          top: 0,
          left: 0,
        }}
      >
        {/* Toggle & New Chat */}
        <div
          className={`w-full flex items-center justify-center mb-4 ${
            toggle ? "mt-[0px]" : "mt-[50px]"
          } md:mt-0`}
        >
          {toggle ? (
            <div className="w-full flex items-center justify-between min-w-0">
              <button
                onClick={handleToggle}
                className="p-[2px] hover:bg-[#e6e5e5] hover:rounded-md flex-shrink-0"
              >
                <img
                  src={ToggleIcon}
                  alt="Toggle"
                  className="w-5 h-5 md:w-6 md:h-6 transform transition-transform duration-300 rotate-180"
                />
              </button>
              <button
                onClick={handleNewChat}
                className="p-[2px] hover:bg-[#e6e5e5] hover:rounded-md flex-shrink-0"
              >
                <img
                  src={NewChatIcon}
                  alt="New Chat"
                  className="w-5 h-5 md:w-6 md:h-6"
                />
              </button>
            </div>
          ) : (
            <div className="flex flex-col gap-2 hidden md:flex">
              <button
                onClick={handleToggle}
                className="p-[2px] hover:bg-[#e6e5e5] hover:rounded-md"
              >
                <img
                  src={ToggleIcon}
                  alt="Toggle"
                  className="w-5 h-5 md:w-6 md:h-6 transform transition-transform duration-300 rotate-[-180]"
                />
              </button>
              <button
                onClick={handleNewChat}
                className="p-[2px] hover:bg-[#e6e5e5] hover:rounded-md"
              >
                <img
                  src={NewChatIcon}
                  alt="New Chat"
                  className="w-5 h-5 md:w-6 md:h-6"
                />
              </button>
            </div>
          )}
        </div>

        {/* Recent Chats */}
        {toggle && (
          <div className={`flex flex-col flex-1 overflow-y-auto w-full gap-2 min-w-0`}>
            <span className="flex pl-[10px] text-[#8E8EA0] font-Poppins text-[11px] md:text-[12px] font-[500] leading-[16px]">
              Recents
            </span>
            <div className="w-full flex flex-col-reverse gap-2 min-w-0">
              {chats.map((chat, index) => (
                <div
                  key={index}
                  onClick={() => handleSelect(chat._id)}
                  onMouseEnter={() => setHoveredChatId(chat._id)}
                  onMouseLeave={() => setHoveredChatId(null)}
                  className={`w-full flex ${
                    toggle
                      ? "py-[8px] px-[12px] justify-between"
                      : "p-2 justify-center"
                  } items-center hover:cursor-pointer min-h-[40px] ${
                    selectedChatId === chat._id
                      ? "bg-[#e6e5e5]"
                      : "hover:bg-[#e6e5e5]"
                  } rounded-[10px] transition-colors min-w-0`}
                >
                  <div
                    className={`flex ${
                      toggle ? "justify-start gap-[12px]" : "justify-center"
                    } items-center flex-1 min-w-0`}
                  >
                    <img
                      src={ChatIcon}
                      alt="Chat"
                      className="w-3 h-3 md:w-4 md:h-4 flex-shrink-0"
                    />
                    {toggle && (
                      <span className="truncate text-[#313133] font-Poppins text-[11px] md:text-[12px] lg:text-[14px] font-[400] leading-[20px] min-w-0">
                        {chat.title}
                      </span>
                    )}
                  </div>
                  {toggle &&
                    (hoveredChatId === chat._id ||
                      selectedChatId === chat._id) && (
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setModalOpenChatId(chat._id);
                        }}
                        className="flex justify-center items-center p-[4px] hover:bg-white hover:rounded-[3px] flex-shrink-0"
                      >
                        <img
                          src={DeleteIcon}
                          alt="Delete"
                          className="w-3 h-3 md:w-4 md:h-4"
                        />
                      </button>
                    )}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Navigation Links */}
        <div className="flex flex-col justify-start">
          <HelpMenu
            toggle={toggle}
            onOpenFaqs={handleOpenFaqs}
            onOpenContactUs={handleOpenContactUs}
            onRecharge={handleRecharge}
            onOpenSchedules={handleOpenSchedules}
            onOpenTerms={handleOpenTerms}
            onOpenPrivacy={handleOpenPrivacy}
          />

          {/* Upgrade (Collapsed Only) */}
          {!toggle && !isSubscribed && (
            <button
              onClick={handleUpgradeClick}
              className="w-full flex justify-center items-center py-4 hover:bg-[#e6e5e5] hover:rounded-[10px] relative group"
              title="Upgrade to Premium"
            >
              <div className="w-5 h-5 md:w-6 md:h-6 bg-gradient-to-r from-[#e61f26] to-[#ff4757] rounded-full flex items-center justify-center animate-pulse">
                <CrownOutlined className="text-white text-sm" />
              </div>
              <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-10">
                Upgrade to Premium
              </div>
            </button>
          )}

          {/* Site Settings (Admin Only) */}
          {isAdmin() && (
            <button
              onClick={handleOpenSiteSettings}
              className={`w-full flex ${
                toggle ? "gap-[8px] pl-2" : "justify-center"
              } items-center py-4 hover:bg-[#e6e5e5] hover:rounded-[10px] min-w-0`}
            >
              <img
                src={SiteSettings}
                alt="Settings"
                className="w-5 h-5 md:w-6 md:h-6 flex-shrink-0"
              />
              {toggle && (
                <span className="text-[#E61F26] font-Poppins text-[12px] md:text-[14px] font-[500] leading-[18px] min-w-0">
                  Settings
                </span>
              )}
            </button>
          )}

          {/* User Profile */}
          <div
            className={`w-full flex ${
              toggle ? "gap-[8px]" : "justify-center"
            } items-center py-4 cursor-pointer min-w-0`}
            onClick={() => setIsSettingsModalVisible(true)}
          >
            <div className="w-8 h-8 md:w-10 md:h-10 flex justify-center items-center text-white font-[700] rounded-full bg-[#D9D9D9] relative flex-shrink-0">
              {toggle ? initials : initials[0]}
              {isSubscribed && (
                <div className="absolute -top-1 -right-1 w-5 h-5 bg-gradient-to-r from-[#e61f26] to-[#ff4757] rounded-full flex items-center justify-center cursor-pointer hover:scale-110 transition-transform">
                  <CrownOutlined className="text-white text-xs" />
                </div>
              )}
            </div>
            {toggle && (
              <div className="flex flex-col items-start justify-between gap-1 flex-1 min-w-0">
                <div className="flex items-center gap-2 w-full min-w-0">
                  <span className="text-[#13343B] font-Poppins text-[12px] md:text-[14px] font-[500] leading-[16px] truncate min-w-0">
                    {userName}
                  </span>
                  {!isSubscribed && (
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleUpgradeClick();
                      }}
                      className="ml-auto bg-gradient-to-r from-[#e61f26] to-[#ff4757] text-white text-xs px-2 py-1 rounded-full hover:scale-105 transition-transform flex items-center gap-1 flex-shrink-0"
                      title="Upgrade to Premium"
                    >
                      <CrownOutlined className="text-xs" />
                      <span>Upgrade</span>
                    </button>
                  )}
                </div>
                <span className="text-[#13343B] font-Poppins text-[11px] md:text-[14px] font-[500] leading-[18px] flex flex-row items-center justify-between">
                  {isAdmin() ? "∞" : creditBalance} Credits
                </span>
              </div>
            )}
          </div>

          {/* Logout */}
          <div
            onClick={handleLogout}
            className={`w-full flex ${
              toggle ? "gap-[8px] pl-2" : "justify-center"
            } items-center py-4 hover:bg-[#e6e5e5] hover:rounded-[10px] cursor-pointer min-w-0`}
          >
            <img
              src={LogoutIcon}
              alt="Logout"
              className="w-5 h-5 md:w-6 md:h-6 flex-shrink-0"
            />
            {toggle && (
              <span className="text-[#13343B] font-Poppins text-[12px] md:text-[14px] font-[500] leading-[18px] min-w-0">
                Logout
              </span>
            )}
          </div>
        </div>

        {/* Delete Modal */}
        <DeleteChatModal
          open={Boolean(modalOpenChatId)}
          onConfirm={handleDeleteConfirm}
          onCancel={handleDeleteCancel}
        />
      </div>

      {/* Upgrade Modal */}
      <UpgradeModal visible={showUpgradeModal} onClose={handleUpgradeClose} />
    </>
  );
}

export default Sidebar;